import { useNavigate } from 'react-router-dom';
import AppContext from '../common/AppContext';
import React from 'react';
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import HealingIcon from '@mui/icons-material/Healing';
import SavingsIcon from '@mui/icons-material/Savings';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FoundationIcon from '@mui/icons-material/Foundation';
import BadgeIcon from '@mui/icons-material/Badge';
import styled from 'styled-components';
import Axios from '../common/Axios';
import { systemGroup } from '../common/types/types';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

interface Props {
    setSystemId?: Function;
    setSystemName?: Function;
    setOrgSystemModalOpen?: Function;
}
const MainPage = ( {setSystemId, setSystemName, setOrgSystemModalOpen}: Props) => {
    const navigate = useNavigate();
    const userInfo = useRecoilValue(Atom.userInfo);
    const initPass = userInfo.initPass; // 비밀번호 초기화 여부

    const [a1SysCnt, setA1SysCnt] = React.useState<number>(0); // 총괄 교부금 결재 건수
    const [b1SysCnt, setB1SysCnt] = React.useState<number>(0); // 운영비 결재 건수
    const [c1SysCnt, setC1SysCnt] = React.useState<number>(0); // 복지기금 결재 건수
    const [c2SysCnt, setC2SysCnt] = React.useState<number>(0); // 희생자 부조금 결재 건수
    const [c3SysCnt, setC3SysCnt] = React.useState<number>(0); // 퇴직급여 충담금 결재 건수
    const [c4SysCnt, setC4SysCnt] = React.useState<number>(0); // 발전기금 결재 건수
    const [c5SysCnt, setC5SysCnt] = React.useState<number>(0); // 자립기금 결재 건수
    const [d1SysCnt, setD1SysCnt] = React.useState<number>(0); // 조합원 관리 결재 건수
    const [e1SysCnt, setE1SysCnt] = React.useState<number>(0); // 지부 운영비 결재 건수
    const [f1SysCnt, setF1SysCnt] = React.useState<number>(0); // 지부장 직무활동비 결재 건수
    const [g1SysCnt, setG1SysCnt] = React.useState<number>(0); // 지부 대회비 결재 건수

    // 조합비 시스템
    const systemsGroupA: systemGroup[] = [
        { id: "A1", title: '총괄 교부금'    , desc: '총괄 교부금 관리'     , icon: <AccountBalanceIcon style={{ fontSize: 28, color: '#1565C0' }} />, visible: "N" },
        { id: "B1", title: '운영비'         , desc: '운영비 수입/지출 관리', icon: <ReceiptLongIcon    style={{ fontSize: 28, color: '#36B37E' }} />, visible: "N" },
        { id: "C1", title: '복지기금'       , desc: '복지기금 관리'        , icon: <CardGiftcardIcon   style={{ fontSize: 28, color: '#FF5630' }} />, visible: "N" },
        { id: "C2", title: '자립기금'       , desc: '자립기금 관리'        , icon: <HealingIcon        style={{ fontSize: 28, color: '#9C27B0' }} />, visible: "N" },
        { id: "C3", title: '발전기금'       , desc: '발전기금 관리'        , icon: <SavingsIcon        style={{ fontSize: 28, color: '#F9A825' }} />, visible: "N" },
        { id: "C4", title: '희생자부조금'    , desc: '희생자부조금 관리'    , icon: <TrendingUpIcon     style={{ fontSize: 28, color: '#2E7D32' }} />, visible: "N" },
        { id: "C5", title: '퇴직급여충당금'  , desc: '퇴직급여충당금 관리'  , icon: <FoundationIcon     style={{ fontSize: 28, color: '#00838F' }} />, visible: "N" },
        { id: "E1", title: '지부 운영비'     , desc: '지부 운영비 관리'     , icon: <GroupsIcon          style={{ fontSize: 28, color: '#000000' }} />, visible: "N" },
        { id: "F1", title: '지부장 직무활동비', desc: '지부장 직무활동비 관리', icon: <EventIcon           style={{ fontSize: 28, color: '#ce6300' }} />, visible: "N" },
        { id: "G1", title: '지부 대회비'     , desc: '지부 대회비 관리'     , icon: <EmojiEventsIcon     style={{ fontSize: 28, color: '#cfc20b' }} />, visible: "N" },
        { id: 'D1', title: '조합원'          , desc: '조합원 가입/철회 관리', icon: <BadgeIcon          style={{ fontSize: 28, color: '#455A64' }} />, visible: "N" },
    ];

    const [groupA, setGroupA] = React.useState<systemGroup[]>(systemsGroupA);

    // 결재자 카드 클릭 시 결재 문서함 탭 자동 이동
    const getAtrzTabBySystemId = (systemId: string): "A" | "B" | "C" | "D" | "E" | "F" | "G" => {
        if (systemId === "A1") return "A";
        if (systemId === "B1") return "B";
        if (systemId === "D1") return "D";
        if (systemId === "E1") return "E";
        if (systemId === "F1") return "F";
        if (systemId === "G1") return "G";
        return "C";
    };

    // 기관별 사용시스템 설정
    React.useEffect(() => {
        let sysACount = 0;
        let sysBCount = 0;
        // 지부 전용 시스템
        if (userInfo.ognzCd && !userInfo.ognzCd.includes("000")) {

            // 지부 + 조합비 권한 + 조합원 권한 둘 다
            if (
                (userInfo.budgetAdmin === "Y" || userInfo.budgetApprover === "Y" || userInfo.budgetViewer === "Y")
                && (userInfo.memberAdmin === "Y" || userInfo.memberApprover === "Y" || userInfo.memberViewer === "Y")
            ) {
                if (userInfo.sysAuthrtE1Yn === "Y") { updateSystemForA("E1", "Y"); sysACount++; } // 지부 운영비
                if (userInfo.sysAuthrtF1Yn === "Y") { updateSystemForA("F1", "Y"); sysACount++; } // 지부장 직무활동비
                if (userInfo.sysAuthrtG1Yn === "Y") { updateSystemForA("G1", "Y"); sysACount++; } // 지부 대회비
                if (userInfo.sysAuthrtD1Yn === "Y") { updateSystemForA("D1", "Y"); sysBCount++; } // 조합원 관리

            // 지부 + 조합비 권한만
            } else if (
                userInfo.budgetAdmin === "Y" || userInfo.budgetApprover === "Y" || userInfo.budgetViewer === "Y"
            ) {
                if (userInfo.sysAuthrtE1Yn === "Y") { updateSystemForA("E1", "Y"); sysACount++; } // 지부 운영비
                if (userInfo.sysAuthrtF1Yn === "Y") { updateSystemForA("F1", "Y"); sysACount++; } // 지부장 직무활동비
                if (userInfo.sysAuthrtG1Yn === "Y") { updateSystemForA("G1", "Y"); sysACount++; } // 지부 대회비

            // 지부 + 조합원 권한만
            } else if (
                userInfo.memberAdmin === "Y" || userInfo.memberApprover === "Y" || userInfo.memberViewer === "Y"
            ) {
                if (userInfo.sysAuthrtD1Yn === "Y") { updateSystemForA("D1", "Y"); sysBCount++; } // 조합원 관리
            }

        // 본부/중앙
        } else if (
            ((userInfo.budgetAdmin === "Y" || userInfo.budgetApprover === "Y" || userInfo.budgetViewer === "Y")
            && (userInfo.memberAdmin === "Y" || userInfo.memberApprover === "Y" || userInfo.memberViewer === "Y"))
            || userInfo.systemAdmin === "Y"
        ) {
            if (userInfo.sysAuthrtA1Yn === "Y") { updateSystemForA("A1", "Y"); sysACount++; } // 총괄 교부금
            if (userInfo.sysAuthrtB1Yn === "Y") { updateSystemForA("B1", "Y"); sysACount++; } // 운영비
            if (userInfo.sysAuthrtC1Yn === "Y") { updateSystemForA("C1", "Y"); sysACount++; } // 복지기금
            if (userInfo.sysAuthrtC2Yn === "Y") { updateSystemForA("C2", "Y"); sysACount++; } // 자립기금
            if (userInfo.sysAuthrtC3Yn === "Y") { updateSystemForA("C3", "Y"); sysACount++; } // 발전기금
            if (userInfo.sysAuthrtC4Yn === "Y") { updateSystemForA("C4", "Y"); sysACount++; } // 희생자 부조금
            if (userInfo.sysAuthrtC5Yn === "Y") { updateSystemForA("C5", "Y"); sysACount++; } // 퇴직급여충당금
            if (userInfo.sysAuthrtD1Yn === "Y") { updateSystemForA("D1", "Y"); sysBCount++; } // 조합원 관리

        } else if (
            userInfo.budgetAdmin === "Y" || userInfo.budgetApprover === "Y" || userInfo.budgetViewer === "Y"
        ) { // 조합비 권한
            if (userInfo.sysAuthrtA1Yn === "Y") { updateSystemForA("A1", "Y"); sysACount++; } // 총괄 교부금
            if (userInfo.sysAuthrtB1Yn === "Y") { updateSystemForA("B1", "Y"); sysACount++; } // 운영비
            if (userInfo.sysAuthrtC1Yn === "Y") { updateSystemForA("C1", "Y"); sysACount++; } // 복지기금
            if (userInfo.sysAuthrtC2Yn === "Y") { updateSystemForA("C2", "Y"); sysACount++; } // 자립기금
            if (userInfo.sysAuthrtC3Yn === "Y") { updateSystemForA("C3", "Y"); sysACount++; } // 발전기금
            if (userInfo.sysAuthrtC4Yn === "Y") { updateSystemForA("C4", "Y"); sysACount++; } // 희생자 부조금
            if (userInfo.sysAuthrtC5Yn === "Y") { updateSystemForA("C5", "Y"); sysACount++; } // 퇴직급여충당금

        } else if (
            userInfo.memberAdmin === "Y" || userInfo.memberApprover === "Y" || userInfo.memberViewer === "Y"
        ) { // 조합원 권한
            if (userInfo.sysAuthrtD1Yn === "Y") { updateSystemForA("D1", "Y"); sysBCount++; } // 조합원 관리
        }

        // 사용 시스템 확인
        if (sysACount + sysBCount === 0) {
            AppContext.openAlert({
                title: "시스템 사용 불가",
                msg: "기관에서 사용하는 시스템이 설정되지 않았습니다.\n\n본부 관리자에게 문의하시기 바랍니다.",
                icon: "warning"
            });
            return;
        } else if (sysACount + sysBCount === 1 && sysBCount === 1) {   // 조합원 관리 시스템만 있는 경우
            if (userInfo.memberAdmin === "Y") {
                navigate('/system/D1mbrasnewmng'); // 조합원 등록 메뉴로
                if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                    setSystemId("D1"); // 시스템 ID
                    setSystemName("조합원"); // 시스템명
                    setOrgSystemModalOpen(false); // 모달
                }
            } else if (userInfo.memberApprover === "Y") {
                navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: "D" } });  // 결재 문서함 메뉴
                if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                    setSystemId("E"); // 시스템 ID
                    setSystemName("결재 문서함"); // 시스템명
                    setOrgSystemModalOpen(false); // 모달
                }
            } else if (userInfo.memberViewer === "Y") {
                navigate('/system/D1mbrasinq/view'); // 조합원 조회 메뉴로
                if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                    setSystemId("D1"); // 시스템 ID
                    setSystemName("조합원"); // 시스템명
                    setOrgSystemModalOpen(false); // 모달
                }            }
        } else if (sysACount + sysBCount === 1 && sysACount === 1) {   // 운영비 관리 시스템만 있는 경우
            if (userInfo.sysAuthrtB1Yn === "Y") {
                if (userInfo.budgetAdmin === "Y") {
                    navigate('/system/B1bgtmbsdsexpndrsdocmng' ); // 지출결의서 메뉴
                    if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                        setSystemId("B1"); // 시스템 ID
                        setSystemName("운영비"); // 시스템명
                        setOrgSystemModalOpen(false); // 모달
                    }
                } else if (userInfo.budgetApprover === "Y") {
                    navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: "B", selectedSystemId: "B1" } });  // 결재 문서함 메뉴
                    if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                        setSystemId("D"); // 시스템 ID
                        setSystemName("결재 문서함"); // 시스템명
                        setOrgSystemModalOpen(false); // 모달
                    }
                } else if (userInfo.budgetViewer === "Y") {
                    navigate('/system/B1bgtmbsdsdpstimplinq/view'); // 집행완료 조회
                    if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                        setSystemId("B1"); // 시스템 ID
                        setSystemName("운영비"); // 시스템명
                        setOrgSystemModalOpen(false); // 모달
                    }
                }
            }
        }

    }, [userInfo, navigate, setOrgSystemModalOpen, setSystemId, setSystemName]);

    // 시스템 사용여부 변경
    const updateSystemForA = (targetId: string, newVal: string) => {
        setGroupA((prevList) =>
            prevList.map((item) => item.id === targetId ? { ...item, visible: newVal } : item)
        );
    };

    // 비밀번호 변경 요청: 비밀번호 초기화한 경우
    React.useEffect(() => {
        if (initPass === "Y") {
            AppContext.openAlert({
                title: "비밀번호 변경 요청",
                msg: "[경고] 초기화 비밀번호를 사용하고 있습니다.\n\n안전한 서비스 이용을 위해\n\"MY INFO\"에서 비빌번호를 변경해 주세요",
                icon: "warning"
            });
            return;
        }
    }, [initPass]);

    // 결재자 시스템별 결재 건수 확인
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/atrz/select-aprvr-sys-atrz-cnt.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                userId: userInfo.userId,
            },
            onSuccessFn: (res: any) => {
                setA1SysCnt(res.result.item.ovrlAtrzCnt ); // 총괄 교부금
                setB1SysCnt(res.result.item.opexpAtrzCnt); // 운영비
                setC1SysCnt(res.result.item.spc01AtrzCnt); // 복지기금
                setC2SysCnt(res.result.item.spc02AtrzCnt); // 자립기금
                setC3SysCnt(res.result.item.spc03AtrzCnt); // 발전기금
                setC4SysCnt(res.result.item.spc04AtrzCnt); // 희생자부조금
                setC5SysCnt(res.result.item.spc05AtrzCnt); // 퇴직급여충당금
                setD1SysCnt(res.result.item.mbrasAtrzCnt); // 조합원 관리
                setE1SysCnt(res.result.item.brOpexpAtrzCnt);   // 지부 운영비
                setF1SysCnt(res.result.item.brChiefAtrzCnt);   // 지부장 직무활동비
                setG1SysCnt(res.result.item.eventAtrzCnt);     // 지부 대회비
                AppContext.hideSpinner();
            },
        });
    }, [userInfo]);

    // 시스템 사용권한 없음 메시지
    function noAuthMsg() {
        AppContext.openAlert({
            title: "시스템 사용권한 없음",
            msg: "조합비 관리 시스템 사용의 권한이 없습니다.\n\n 본부 관리자에게 문의하시기 바랍니다.",
            icon: "warning"
        });
        return;
    }

    return (
        <Container>
            <ContentWrapper>
                <PageTitle>{userInfo.ognzNm} 서비스</PageTitle>

                {/* 조합비 시스템 */}
                <Section>
                    <SectionHeader>
                        <SectionGroup>
                            <SectionTitle>조합비 관리</SectionTitle>
                            <Badge color={COLORS.primary}>
                                {groupA.filter((sys) => sys.visible === "Y" && sys.id !== "D1").length}
                            </Badge>
                        </SectionGroup>

                        <SectionGroup>
                            <SectionTitle>조합원 관리</SectionTitle>
                            <Badge color={COLORS.secondary}>
                                {groupA.filter((sys) => sys.visible === "Y" && sys.id === "D1").length}
                            </Badge>
                        </SectionGroup>
                    </SectionHeader>
                    <CardSection>
                        {groupA.filter((sys) => sys.visible === "Y").map((sys) => (
                            <Card key={sys.id} $hoverColor={COLORS.primary} $bgColor={sys.id === "D1" ? "#FFF7E6" : ""} onClick={() => {
                                // 총괄 교부금
                                if (sys.id === "A1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/A1bgtovrlexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/A1bgtovrldpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 운영비
                                } else if (sys.id === "B1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/B1bgtmbsdsexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/B1bgtmbsdsdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 복지기금
                                } else if (sys.id === "C1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/C1bgtspcexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/C1bgtspcdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 자립기금
                                } else if (sys.id === "C2") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/C2bgtspcexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/C2bgtspcdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 발전기금
                                } else if (sys.id === "C3") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/C3bgtspcexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/C3bgtspcdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 희생자부조금
                                } else if (sys.id === "C4") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/C4bgtspcexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/C4bgtspcdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 퇴직급여충당금
                                } else if (sys.id === "C5") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합비 관리자
                                        navigate('/system/C5bgtspcexpndrsdocmng' ); // 지출결의서 메뉴
                                    } else if (userInfo.budgetApprover === "Y") {    // 조합비 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });  // 결재 문서함 메뉴
                                    } else if (userInfo.budgetViewer === "Y") {    // 조합비 조회자
                                        navigate('/system/C5bgtspcdpstimplinq/view'); // 집행완료 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 조합원 관리
                                } else if (sys.id === "D1") {
                                    if (userInfo.memberAdmin === "Y" || userInfo.systemAdmin === "Y") { // 조합원 관리자
                                         navigate('/system/D1mbrasnewmng'); // 조합원 등록
                                    } else if (userInfo.memberApprover === "Y") {    // 조합원 결재자
                                         navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: "D" } });  // 결재 문서함 메뉴
                                    } else if (userInfo.memberViewer === "Y") {    // 조합원 조회자
                                        navigate('/system/D1mbrasinq/view'); // 조합원 조회
                                    } else {
                                        noAuthMsg();
                                    }
                                // 지부 운영비
                                } else if (sys.id === "E1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") {
                                        navigate('/system/E1bgtbrexpndrsdocmng');
                                    } else if (userInfo.budgetApprover === "Y") {
                                        navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });
                                    } else if (userInfo.budgetViewer === "Y") {
                                        navigate('/system/E1bgtbrdpstimplinq/view');
                                    } else {
                                        noAuthMsg();
                                    }

                                // 지부장 직무활동비
                                } else if (sys.id === "F1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") {
                                        navigate('/system/F1bgtbrexpndrsdocmng');
                                    } else if (userInfo.budgetApprover === "Y") {
                                        navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });
                                    } else if (userInfo.budgetViewer === "Y") {
                                        navigate('/system/F1bgtbrdpstimplinq/view');
                                    } else {
                                        noAuthMsg();
                                    }

                                // 지부 대회비
                                } else if (sys.id === "G1") {
                                    if (userInfo.budgetAdmin === "Y" || userInfo.systemAdmin === "Y") {
                                        navigate('/system/G1bgtbrexpndrsdocmng');
                                    } else if (userInfo.budgetApprover === "Y") {
                                        navigate('/system/Eatrzdocprcsmng', { state: { defaultTabId: getAtrzTabBySystemId(sys.id), selectedSystemId: sys.id } });
                                    } else if (userInfo.budgetViewer === "Y") {
                                        navigate('/system/G1bgtbrdpstimplinq/view');
                                    } else {
                                        noAuthMsg();
                                    }
                                }

                                // Left Menu에서 모달로 호출한 경우
                                if (setSystemId && setSystemName && setOrgSystemModalOpen) {
                                    setSystemId(sys.id); // 시스템 ID
                                    setSystemName(sys.title); // 시스템명
                                    setOrgSystemModalOpen(false); // 모달
                                }
                            }}>
                                <CardIcon color={'#4a90e2'}>{sys.icon}
                                    <span className="Pretendard-Bold fcE53935 fs18 ls075 taU fwB ml20">
                                        {
                                              (sys.id === "A1" && a1SysCnt !== 0) ? "결재 " + a1SysCnt + "건"
                                            : (sys.id === "B1" && b1SysCnt !== 0) ? "결재 " + b1SysCnt + "건"
                                            : (sys.id === "C1" && c1SysCnt !== 0) ? "결재 " + c1SysCnt + "건"
                                            : (sys.id === "C2" && c2SysCnt !== 0) ? "결재 " + c2SysCnt + "건"
                                            : (sys.id === "C3" && c3SysCnt !== 0) ? "결재 " + c3SysCnt + "건"
                                            : (sys.id === "C4" && c4SysCnt !== 0) ? "결재 " + c4SysCnt + "건"
                                            : (sys.id === "C5" && c5SysCnt !== 0) ? "결재 " + c5SysCnt + "건"
                                            : (sys.id === "D1" && d1SysCnt !== 0) ? "결재 " + d1SysCnt + "건"
                                            : (sys.id === "E1" && e1SysCnt !== 0) ? "결재 " + e1SysCnt + "건"
                                            : (sys.id === "F1" && f1SysCnt !== 0) ? "결재 " + f1SysCnt + "건"
                                            : (sys.id === "G1" && g1SysCnt !== 0) ? "결재 " + g1SysCnt + "건"
                                            : ""
                                        }
                                    </span>
                                </CardIcon>
                                <div>
                                    <CardTitle>{sys.title + (sys.id === "F1" ? "" : " 관리")}</CardTitle>
                                    <CardDesc>{sys.desc}</CardDesc>
                                </div>
                                {/* <CardAction color={COLORS.primary}>{authApprover === "Y" ? "결재하기" : "접속하기"}</CardAction> */}
                                <CardAction color={COLORS.primary}>접속하기</CardAction>
                            </Card>
                        ))}
                    </CardSection>
                </Section>

            {/* 로그아웃 버튼 */}
            <div className='w100p dpFlx aiC jcC pt40 pb30'>
                <div className='w260'>
                    <div className='dpFlx aiC jcC'>
                        <button className='flx1 h62 bgc313131 bdrd20 dpFlx aiC jcC csP ml10' onClick={() => {
                            // setOrgSystemModalOpen(false);
                            AppContext.openAlert({
                                title: "로그아웃",
                                msg: "로그아웃 하시겠습니까?",
                                icon: "check",
                                confirmText: "로그아웃",
                                handleConfirm: AppContext.goLogout
                            });
                        }}>
                            <span className="SpoqaHanSansNeo-Bold fs18 ls08 fcWhite">로그아웃</span>
                        </button>
                    </div>
                </div>
            </div>
            </ContentWrapper>
        </Container>
    )
}

// =========== styled-component ============
// 테마 색상 상수
const COLORS = {
    bg: '#f4f7f6',
    cardBg: '#ffffff',
    textMain: '#333333',
    textSub: '#666666',
    primary: '#4a90e2',
    secondary: '#e27d60',
};

const Container = styled.div`
    font-family: 'Pretendard-Regular';
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    padding: 24px 16px 0;
    overflow-x: hidden;

    @media (max-width: 1024px) {
        padding: 20px 14px 0;
    }

    @media (max-width: 768px) {
        padding: 16px 12px 0;
    }

    @media (max-width: 480px) {
        padding: 14px 8px 0;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
`;

const PageTitle = styled.h1`
    text-align: center;
    margin: 0 0 42px 0;
    font-size: 2rem;
    color: #2c3e50;
    line-height: 1.3;
    word-break: keep-all;

    @media (max-width: 1024px) {
        margin-bottom: 34px;
        font-size: 1.8rem;
    }

    @media (max-width: 768px) {
        margin-bottom: 26px;
        font-size: 1.45rem;
    }

    @media (max-width: 480px) {
        margin-bottom: 22px;
        font-size: 1.25rem;
    }
`;

const Section = styled.section`
    margin-bottom: 48px;
    width: 100%;

    @media (max-width: 768px) {
        margin-bottom: 36px;
    }
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 22px;
    padding-bottom: 14px;
    border-bottom: 2px solid #e0e0e0;
    gap: 16px;
    flex-wrap: wrap;
    text-align: center;

    @media (max-width: 768px) {
        margin-bottom: 18px;
        padding-bottom: 12px;
        gap: 10px 14px;
    }

    @media (max-width: 480px) {
        gap: 8px 10px;
    }
`;

const SectionGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: nowrap;
    min-width: 0;

    @media (max-width: 768px) {
        gap: 6px;
    }
`;

const SectionTitle = styled.h2`
    margin: 0;
    font-size: 1.45rem;
    color: ${COLORS.textMain};
    line-height: 1.3;
    word-break: keep-all;

    @media (max-width: 1024px) {
        font-size: 1.28rem;
    }

    @media (max-width: 768px) {
        font-size: 1.08rem;
    }

    @media (max-width: 480px) {
        font-size: 1rem;
    }
`;

const Badge = styled.span`
    margin-left: 0;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 1.15rem;
    color: white;
    font-weight: bold;
    background-color: ${props => props.color || COLORS.primary};
    line-height: 1;
    flex-shrink: 0;

    @media (max-width: 768px) {
        padding: 5px 13px;
        font-size: 0.95rem;
    }
`;

const CardSection = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 14px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

const CardAction = styled.div`
    font-weight: bold;
    font-size: 0.95rem;
    margin-top: auto;
    display: flex;
    align-items: center;
    color: ${props => props.color};
    line-height: 1.2;

    &::after {
        content: '→';
        margin-left: 6px;
        transition: margin-left 0.2s ease;
    }

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`;

interface CardProps {
    $hoverColor: string;
    $bgColor?: string;
}

const Card = styled.div<CardProps>`
    background: ${COLORS.cardBg};
    border-radius: 16px;
    padding: 18px 18px 16px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.14);
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
    cursor: pointer;
    box-sizing: border-box;
    margin: 0;
    border: 2px solid #EBEBEB;
    width: 200px;
    min-height: 172px;
    height: auto;
    background-color: ${({ $bgColor }) => $bgColor || '#ffffff'};
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.10);
        border-color: ${props => props.$hoverColor};
    }

    &:hover ${CardAction}::after {
        margin-left: 12px;
    }

    @media (max-width: 1024px) {
        width: calc(33.333% - 10px);
        min-width: 190px;
        padding: 18px 16px 16px;
    }

    @media (max-width: 768px) {
        width: calc(50% - 6px);
        min-width: 0;
        min-height: 164px;
        border-radius: 14px;
        padding: 16px 14px 15px;
    }

    @media (max-width: 560px) {
        width: 100%;
        min-height: 156px;
        padding: 16px 14px 14px;
    }
`;

// 카드 내부 요소들
const CardIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 1.5rem;
    margin-bottom: 8px;
    transition: color 0.3s ease;
    flex-wrap: wrap;
    gap: 6px 8px;
    line-height: 1.3;

    @media (max-width: 768px) {
        margin-bottom: 10px;
    }
`;

const CardTitle = styled.h3`
    font-size: 1.18rem;
    font-weight: bold;
    margin: 0 0 10px 0;
    color: ${COLORS.textMain};
    line-height: 1.35;
    word-break: keep-all;

    @media (max-width: 768px) {
        font-size: 1.06rem;
        margin-bottom: 8px;
    }
`;

const CardDesc = styled.p`
    font-size: 0.95rem;
    color: ${COLORS.textSub};
    line-height: 1.55;
    margin: 0 0 18px 0;
    word-break: keep-all;

    @media (max-width: 768px) {
        font-size: 0.9rem;
        line-height: 1.5;
        margin-bottom: 16px;
    }
`;

export default MainPage;
